import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { AdminCollectionKreditor, KreditorParam } from "../models/adminCollection";
import { FullCustomerCollection, ICCSearchForm } from "../models/customer";
import { store } from "./store";
import { cgiRef, city, collectionDate, companyName, country, createDate, koNumber } from "../common/options/collectionOpt";
import { Pagination, PagingParams } from "../models/pagination";
export default class AdminCollectionStore {

  adminCollections: FullCustomerCollection[] | [] = [];
  loadingAdminCollections = false;
  selectedCollectionReport: FullCustomerCollection | undefined = undefined;

  adminCollectionKreditors: AdminCollectionKreditor[] | [] = [];
  loadingAdminCollectionKreditors = false;
  loadingKoNumberUpdate = false;

  loadingMarkReadCollectionRead = false;
  idsMarkReadCollectionRead: string[] | [] = [];

  sortOption = koNumber;
  sortValue = true;

  ccPagination: Pagination | null = null;
  ccPagingParams = new PagingParams();
  ccPage: number = 1;
  ccPredicate = new Map().set('orderBy', 'createdAtDesc');

  constructor() {
    makeAutoObservable(this);
  }

  resetStoreData = () => {
    runInAction(() => {
      this.adminCollections = [];
      this.selectedCollectionReport = undefined;
      this.adminCollectionKreditors = [];
    })
  }


  ccSetPage = (pageNumber: number) => {
    runInAction(() => this.ccPage = pageNumber);

  }

  setCcPagingParams = (pagingParams: PagingParams) => {
    runInAction(() => this.ccPagingParams = pagingParams);
  }


  setCcSearchPredicate = (v: ICCSearchForm) => {
    if (v) {
      this.ccPredicate.clear();
      if (v.orderBy) {
        this.ccPredicate.set('orderBy', 'createdAtDesc');
      } else {
        this.ccPredicate.set('orderBy', 'createdAt');
      }

      this.ccPredicate.set('koNumber', v.koNumber);
      this.ccPredicate.set('refNr', v.refNr);
      this.ccPredicate.set('companyName', v.companyName);
      this.ccPredicate.set('city', v.city);
      this.ccPredicate.set('country', v.country);
    }
  }

  get ccSearchFormValues(): ICCSearchForm {
    const v: ICCSearchForm = {
      orderBy: this.ccPredicate.get('orderBy') === 'createdAt' ? false : true,
      koNumber: this.ccPredicate.get('koNumber') ?? '',
      refNr: this.ccPredicate.get('refNr') ?? '',
      companyName: this.ccPredicate.get('companyName') ?? '',
      city: this.ccPredicate.get('city') ?? '',
      country: this.ccPredicate.get('country') ?? ''
    }
    return v;
  }
  get ccParams() {
    const params = new URLSearchParams();
    params.append('pageNumber', this.ccPagingParams.pageNumber.toString());
    params.append('pageSize', this.ccPagingParams.pageSize.toString());
    this.ccPredicate.forEach((value, key) => {
      params.append(key, value);
    })
    return params;
  }

  loadAdminCollectionPagedReports = async () => {
    this.loadingAdminCollections = true;
    try {
      const result = await agent.AdminCollection.getAdminCollectionPagedList(this.ccParams);
      runInAction(() => {
        this.adminCollections = result.data.data;
        this.ccPagination = result.data.pagination;
        this.loadingAdminCollections = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingAdminCollections = false;
      });
    }
  }

  // loadAdminCollectionReports = async () => {
  //   this.loadingAdminCollections = true;

  //   try {
  //     const result = await agent.AdminCollection.getAdminCollectionList();
  //     runInAction(() => {
  //       this.adminCollections = result;
  //       this.loadingAdminCollections = false;
  //     });
  //   } catch (error) {
  //     runInAction(() => {
  //       this.loadingAdminCollections = false;
  //     });
  //   }
  // }

  loadAdminCollectionKreditors = async (kreditorParam: KreditorParam) => {
    this.loadingAdminCollectionKreditors = true;

    try {
      const result = await agent.AdminCollection.getKreditorList(kreditorParam);
      runInAction(() => {
        this.adminCollectionKreditors = result;
        this.loadingAdminCollectionKreditors = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingAdminCollectionKreditors = false;
      });
    }
  }

  setSelectedCollectionReport = (selectedCollectionReport: FullCustomerCollection) => {
    if (selectedCollectionReport) {
      runInAction(() => this.selectedCollectionReport = selectedCollectionReport);
    }
  }
  clearSelectedCollectionReport = () => {
    this.selectedCollectionReport = undefined;
  }

  updateSelectedCollectionReport = (userName: string | null, isRead: boolean, isNew: boolean) => {
    if (this.selectedCollectionReport !== undefined && this.adminCollections.length > 0) {
      const listCollection = [...this.adminCollections]
      const index = this.adminCollections.findIndex(x => x.id === this.selectedCollectionReport?.id);
      if (index >= 0) {
        runInAction(() => {
          let uptSelCol = listCollection[index];
          if (isRead) {
            uptSelCol = {
              ...uptSelCol,
              t1aUnReadCommentCount: 0
            }
          }
          if (userName && isNew && store.userStore.user?.fullName !== userName) {
            uptSelCol = {
              ...uptSelCol,
              t1aUnReadCommentCount: uptSelCol.t1aUnReadCommentCount + 1
            }
          }
          listCollection[index] = uptSelCol;
          this.adminCollections = listCollection;
          this.selectedCollectionReport = uptSelCol;
        });
      }

    }
  }

  addKoNumberToCollection = async (id: string, koNumber: string): Promise<boolean> => {
    this.loadingKoNumberUpdate = true;
    let idsMarkReadCollectionRead = [...this.idsMarkReadCollectionRead];
    idsMarkReadCollectionRead.push(id);
    try {

      runInAction(() => this.idsMarkReadCollectionRead = idsMarkReadCollectionRead)
      await agent.AdminCollection.addKoNumberToCollection(id, koNumber);
      runInAction(() => {
        if (id) {
          let updateAdminCollections = [...this.adminCollections];
          let index = updateAdminCollections.findIndex(x => x.id === id);
          if (index >= 0) {
            const customerCollection = updateAdminCollections[index];
            customerCollection.koNumber = koNumber;
            updateAdminCollections[index] = customerCollection;
            idsMarkReadCollectionRead = idsMarkReadCollectionRead.filter(x => x !== id);
            runInAction(() => {
              this.adminCollections = updateAdminCollections;
              this.clearSelectedCollectionReport();
              this.idsMarkReadCollectionRead = idsMarkReadCollectionRead;
            });
            this.loadingKoNumberUpdate = false;
          }
        }
        toast.success("Collection Report updated successfully");
      })
      return true;
    } catch (error) {
      console.log(error);
      idsMarkReadCollectionRead = idsMarkReadCollectionRead.filter(x => x !== id);
      runInAction(() => {
        this.loadingKoNumberUpdate = false;
        this.idsMarkReadCollectionRead = idsMarkReadCollectionRead;
        this.clearSelectedCollectionReport();
        toast.success("Failed to update Collection Report");
      })
     
    }
    return false;
  }

  markReadCollectionRead = async (id: string) => {
    let idsMarkReadCollectionRead = [...this.idsMarkReadCollectionRead];
    idsMarkReadCollectionRead.push(id);
    try {
      runInAction(() => this.idsMarkReadCollectionRead = idsMarkReadCollectionRead)
      await agent.AdminCollection.markReadCollectionRead(id);
      runInAction(() => {
        if (id) {
          let updateAdminCollections = [...this.adminCollections];
          let index = updateAdminCollections.findIndex(x => x.id === id);
          if (index >= 0) {
            const customerCollection = updateAdminCollections[index];
            customerCollection.isUpdated = false;
            updateAdminCollections[index] = customerCollection;
            idsMarkReadCollectionRead = idsMarkReadCollectionRead.filter(x => x !== id);
            runInAction(() => {
              this.adminCollections = updateAdminCollections;
              this.idsMarkReadCollectionRead = idsMarkReadCollectionRead;
            });
          }
        }
        toast.success("Collection Report updated successfully");
      })
    } catch (error) {
      console.log(error);
      idsMarkReadCollectionRead = idsMarkReadCollectionRead.filter(x => x !== id);
      runInAction(() => {
        this.idsMarkReadCollectionRead = idsMarkReadCollectionRead;
        toast.success("Failed to update Collection Report");
      });
    }
  }

  deleteCustomerCollection = async (id: string) => {
    try {
      await agent.AdminCollection.deleteCustomerCollection(id);
      runInAction(() => {
        if (id) {
          this.adminCollections = this.adminCollections.filter(x => x.id !== id);
        }
        toast.success("Collection Report deleted successfully");
      })
    } catch (error) {
      console.log(error);
      toast.success("Failed to delete Collection Report");
    }
  }

  createCrfForm = async (id: string, koNumber: string) => {
    this.loadingKoNumberUpdate = true;
    try {

      await agent.AdminCollection.createCrfForm(id, koNumber);
      runInAction(() => {
        this.loadingKoNumberUpdate = false;
      })
      toast.success("CRF form created successfully");
    } catch (error) {
      console.log(error);
      this.loadingKoNumberUpdate = false;
      toast.success("Failed to create CRF Form");
    }
  }

  sortcustomerCollection = (type: string) => {
    if (this.sortOption !== type) {
      this.sortValue = true;
    }
    else {
      this.sortValue = !this.sortValue;
    }
    runInAction(() => {
      this.sortOption = type;
      if (type === koNumber) {
        this.adminCollections = this.adminCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.koNumber < b.koNumber)
              return -1;
            if (a.koNumber > b.koNumber)
              return 1;
            return 0;
          }
          else {

            if (a.koNumber > b.koNumber)
              return -1;
            if (a.koNumber < b.koNumber)
              return 1;
            return 0;
          }
        });
      }
      if (type === cgiRef) {
        this.adminCollections = this.adminCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.cgiRefNumber < b.cgiRefNumber)
              return -1;
            if (a.cgiRefNumber > b.cgiRefNumber)
              return 1;
            return 0;
          }
          else {

            if (a.cgiRefNumber > b.cgiRefNumber)
              return -1;
            if (a.cgiRefNumber < b.cgiRefNumber)
              return 1;
            return 0;
          }
        });
      }
      if (type === companyName) {
        this.adminCollections = this.adminCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.companyName < b.contactInfo.companyName)
              return -1;
            if (a.contactInfo.companyName > b.contactInfo.companyName)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.companyName > b.contactInfo.companyName)
              return -1;
            if (a.contactInfo.companyName < b.contactInfo.companyName)
              return 1;
            return 0;
          }
        });
      }
      if (type === city) {
        this.adminCollections = this.adminCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.city < b.contactInfo.city)
              return -1;
            if (a.contactInfo.city > b.contactInfo.city)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.city > b.contactInfo.city)
              return -1;
            if (a.contactInfo.city < b.contactInfo.city)
              return 1;
            return 0;
          }
        });
      }
      if (type === country) {
        this.adminCollections = this.adminCollections.sort((a, b) => {
          if (this.sortValue) {
            if (a.contactInfo.country < b.contactInfo.country)
              return -1;
            if (a.contactInfo.country > b.contactInfo.country)
              return 1;
            return 0;
          }
          else {
            if (a.contactInfo.country > b.contactInfo.country)
              return -1;
            if (a.contactInfo.country < b.contactInfo.country)
              return 1;
            return 0;
          }
        });
      }
      if (type === createDate) {
        this.adminCollections = this.adminCollections.sort((a, b) => {

          const dateA = new Date(a.createdAt || new Date());
          const dateB = new Date(b.createdAt || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }
      if (type === collectionDate) {
        this.adminCollections = this.adminCollections.sort((a, b) => {

          const dateA = new Date(a.collectionDate || new Date());
          const dateB = new Date(b.collectionDate || new Date());

          if (this.sortValue) {
            return dateA.getTime() - dateB.getTime();
          } else {
            return dateB.getTime() - dateA.getTime();
          }
        });
      }

    })
  }
}
